import { render, staticRenderFns } from "./BlockTxTable.vue?vue&type=template&id=7e364a6e&scoped=true"
import script from "./BlockTxTable.vue?vue&type=script&lang=js"
export * from "./BlockTxTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e364a6e",
  null
  
)

export default component.exports